import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import AdvancedHotkey from './component';
import { orderGridOpenMarkShippedModal } from '../../../store/orders/grid/orders.grid.header.actions';
import { BULK_MAS_PAGE } from '../../../orders/mark-as-shipped/constants';
import {
  CANCELLED_ID,
  PENDING_FULFILLMENT_ID,
  REJECTED_FULFILLMENT_ID,
  SHIPPED_ID,
} from '../../../pages/orders-page/orders-page-view-constants';
import { useTopLevelOrdersViewId } from '../../../pages/orders-page/orders-left-nav/orders-left-nav-context';

export const messages = defineMessages({
  name: {
    description: 'ordersPage.MarkAsShippedBulkHotkey',
    defaultMessage: 'Mark As Shipped Bulk',
    id: 'sWCn4G',
  },
});

export const hotkey = ['m', 'b'];

const viewsWithoutMarkAsShipped = [PENDING_FULFILLMENT_ID, REJECTED_FULFILLMENT_ID, SHIPPED_ID, CANCELLED_ID];

const isDisabled = (ordersGridViewId) => {
  return ordersGridViewId && viewsWithoutMarkAsShipped.includes(ordersGridViewId);
};

const MarkAsShippedBulkHotkey = ({ children }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const ordersGridViewId = useTopLevelOrdersViewId();

  const handler = useCallback(() => {
    if (!isDisabled(ordersGridViewId)) {
      dispatch(orderGridOpenMarkShippedModal(BULK_MAS_PAGE));
    }
  }, [dispatch, ordersGridViewId]);

  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['mb'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

MarkAsShippedBulkHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MarkAsShippedBulkHotkey;
